
import RouterPage from './home/Routerpage';
import * as React from 'react'
import './App.css';

function App() {
  return (
      <div className="App">
        <main id="main-content">
          <RouterPage />
        </main>
      </div>
    );
}

export default App;